import "./style.less";
import ChangePasswordForm from "./directive";

const modul = angular
    .module("ChangePasswordFormModule", [])

    .directive("changePasswordForm", ChangePasswordForm);

export default modul.name;
